import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '~/styles';

interface IGetDimensionType {
  isMobile?: boolean;
  isTablet?: boolean;
  isLaptop?: boolean;
  isDesktopLarge?: boolean;
}

const dimensions = {
  isMobile: {
    width: 83,
    height: 83,
  },
  isTablet: {
    width: 95,
    height: 95,
  },
  isLaptop: {
    width: 125,
    height: 125,
  },
  isDesktopLarge: {
    width: 143,
    height: 143,
  },
};

const getDimensionType = (dimensionData: IGetDimensionType) => {
  if (dimensionData.isMobile) {
    return dimensions.isMobile;
  }
  if (dimensionData.isTablet) {
    return dimensions.isTablet;
  }
  if (dimensionData.isLaptop) {
    return dimensions.isLaptop;
  }

  return dimensions.isDesktopLarge;
};

const DigitalClientIcon = () => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.mobile.max });
  const isTablet = useMediaQuery({ maxWidth: Breakpoints.tablet.max });
  const isLaptop = useMediaQuery({ maxWidth: Breakpoints.laptop.max });
  const isDesktopLarge = useMediaQuery({ maxWidth: Breakpoints.desktopLarge.max });

  return (
    <svg
      width={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).width
      }
      height={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).height
      }
      viewBox="0 0 153 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_22814_53125)">
        <circle cx="76.8349" cy="71.9248" r="71.9248" fill="#AAD7E1" />
      </g>
      <path
        d="M28.4856 65.2134C40.5627 53.177 56.9456 45.777 75.0088 45.777C93.0719 45.777 109.455 53.177 121.532 65.2134C123.772 67.4315 127.308 67.3588 129.443 65.0497C131.579 62.7406 131.509 59.0497 129.286 56.8315C115.213 42.777 96.0825 34.1406 75.0088 34.1406C53.9351 34.1406 34.8042 42.777 20.7142 56.8134C18.4913 59.0497 18.4213 62.7224 20.5567 65.0497C22.6921 67.377 26.2452 67.4497 28.4681 65.2134H28.4856ZM75.0088 74.8679C84.9505 74.8679 94.0171 78.7043 100.948 85.0497C103.276 87.177 106.812 86.9406 108.86 84.5406C110.908 82.1406 110.68 78.4497 108.37 76.3224C99.4781 68.177 87.786 63.2315 75.0088 63.2315C62.2315 63.2315 50.5395 68.177 41.6654 76.3224C39.3375 78.4497 39.1275 82.1224 41.1753 84.5406C43.2232 86.9588 46.7588 87.177 49.0867 85.0497C56.0004 78.7043 65.067 74.8679 75.0263 74.8679H75.0088ZM86.2107 103.959C86.2107 100.873 85.0305 97.9129 82.9297 95.7307C80.829 93.5484 77.9797 92.3224 75.0088 92.3224C72.0378 92.3224 69.1885 93.5484 67.0878 95.7307C64.987 97.9129 63.8068 100.873 63.8068 103.959C63.8068 107.045 64.987 110.005 67.0878 112.187C69.1885 114.369 72.0378 115.595 75.0088 115.595C77.9797 115.595 80.829 114.369 82.9297 112.187C85.0305 110.005 86.2107 107.045 86.2107 103.959Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_22814_53125"
          x="0.910156"
          y="0"
          width="151.85"
          height="151.852"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22814_53125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22814_53125"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

const DailyHistoryIcon = () => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.mobile.max });
  const isTablet = useMediaQuery({ maxWidth: Breakpoints.tablet.max });
  const isLaptop = useMediaQuery({ maxWidth: Breakpoints.laptop.max });
  const isDesktopLarge = useMediaQuery({ maxWidth: Breakpoints.desktopLarge.max });

  return (
    <svg
      width={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).width
      }
      height={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).height
      }
      viewBox="0 0 93 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_22814_57488)">
        <circle cx="46.5021" cy="41.5099" r="41.5099" fill="#AAD7E1" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6471 65.0709H68.3791V61.8655H27.2298V20.1953H24.0645V63.4682L25.6471 65.0709ZM30.3951 57.0574V31.4142L31.9778 29.8115H38.3085L39.8911 31.4142V57.0574L38.3085 58.6601H31.9778L30.3951 57.0574ZM36.7258 55.4547V33.0169H33.5605V55.4547H36.7258ZM55.7178 25.0034V57.0574L57.3005 58.6601H63.6311L65.2138 57.0574V25.0034L63.6311 23.4007H57.3005L55.7178 25.0034ZM62.0485 26.6061V55.4547H58.8831V26.6061H62.0485ZM43.0565 57.0574V37.825L44.6391 36.2223H50.9698L52.5525 37.825V57.0574L50.9698 58.6601H44.6391L43.0565 57.0574ZM49.3871 55.4547V39.4277H46.2218V55.4547H49.3871Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_22814_57488"
          x="0.992188"
          y="0"
          width="91.0195"
          height="91.0234"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22814_57488"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22814_57488"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

const ConsumptionAlertsIcon = () => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.mobile.max });
  const isTablet = useMediaQuery({ maxWidth: Breakpoints.tablet.max });
  const isLaptop = useMediaQuery({ maxWidth: Breakpoints.laptop.max });
  const isDesktopLarge = useMediaQuery({ maxWidth: Breakpoints.desktopLarge.max });

  return (
    <svg
      width={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).width
      }
      height={
        getDimensionType({
          isMobile,
          isTablet,
          isLaptop,
          isDesktopLarge,
        }).height
      }
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_22814_57491)">
        <circle cx="46.4904" cy="41.5099" r="41.5099" fill="#AAD7E1" />
      </g>
      <path
        d="M41.8591 63.9473L52.0859 59.5937C52.2725 60.8546 52.0365 62.1418 51.4149 63.2536C50.7933 64.3654 49.8213 65.2389 48.6513 65.7369C47.4814 66.235 46.1797 66.3295 44.9504 66.0056C43.7211 65.6817 42.6338 64.9577 41.8591 63.9473V63.9473ZM57.4549 12.6086C63.444 15.8911 67.9401 20.1035 70.8974 25.2403C73.8546 30.377 75.2471 36.3891 75.0863 43.2304C75.073 43.8032 74.8333 44.3471 74.4201 44.7427C74.0068 45.1382 73.4538 45.3529 72.8827 45.3395C72.3116 45.3262 71.7692 45.0858 71.3748 44.6714C70.9804 44.257 70.7663 43.7024 70.7797 43.1296C70.9232 37.0485 69.7116 31.8196 67.1678 27.3998C64.624 22.98 60.7107 19.3146 55.3906 16.4007C54.8891 16.1258 54.5171 15.6624 54.3564 15.1124C54.1957 14.5624 54.2594 13.9709 54.5335 13.4681C54.8077 12.9652 55.2698 12.5922 55.8181 12.431C56.3665 12.2698 56.9563 12.3337 57.4578 12.6086H57.4549ZM31.1843 25.3382C35.1348 23.5691 39.6153 23.4044 43.6843 24.8788C47.7533 26.3533 51.0941 29.352 53.0047 33.2449L53.286 33.8495L56.984 42.1737L61.8591 46.4063C62.1262 46.6367 62.3558 46.9073 62.6229 47.3421L62.7923 47.6704C62.9835 48.1027 63.0879 48.5686 63.0994 49.0414C63.111 49.5143 63.0295 49.9847 62.8597 50.426C62.6898 50.8672 62.4349 51.2705 62.1095 51.6129C61.7841 51.9553 61.3947 52.23 60.9634 52.4213L31.3106 65.577C30.7644 65.8189 30.1666 65.9204 29.5714 65.8721C28.9763 65.8238 28.4025 65.6274 27.9021 65.3006C27.4018 64.9738 26.9906 64.5269 26.706 64.0005C26.4213 63.4741 26.2721 62.8848 26.2719 62.2859L26.269 55.5396L22.7031 47.5005C21.8059 45.4874 21.3135 43.3166 21.2541 41.1124C21.1948 38.9082 21.5696 36.7139 22.3572 34.6552C23.1448 32.5965 24.3296 30.7138 25.8438 29.1151C27.358 27.5163 29.1719 26.2328 31.1814 25.3382H31.1843ZM56.7744 22.9771C59.5508 24.4945 61.7759 26.703 63.4239 29.5679C65.0719 32.4329 65.8672 35.4706 65.7897 38.6379C65.7829 38.9215 65.7205 39.2009 65.606 39.4603C65.4915 39.7197 65.3272 39.954 65.1224 40.1497C64.9177 40.3454 64.6765 40.4988 64.4127 40.601C64.1488 40.7032 63.8675 40.7524 63.5847 40.7456C63.3019 40.7387 63.0232 40.6761 62.7646 40.5613C62.5059 40.4465 62.2723 40.2817 62.0772 40.0764C61.882 39.8711 61.7291 39.6292 61.6272 39.3646C61.5252 39.1 61.4762 38.8178 61.483 38.5342C61.5405 36.1674 60.9519 33.9129 59.6943 31.7274C58.4368 29.5391 56.783 27.8979 54.713 26.7692C54.2116 26.4951 53.8393 26.0324 53.678 25.4829C53.5167 24.9335 53.5797 24.3423 53.8531 23.8395C54.1264 23.3366 54.5878 22.9633 55.1357 22.8015C55.6835 22.6398 56.273 22.703 56.7744 22.9771V22.9771Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_22814_57491"
          x="0.980469"
          y="0"
          width="91.0195"
          height="91.0234"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22814_57491"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22814_57491"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

const DescriptionPlanIcon = () => {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9792 0.936008C11.2039 0.729254 11.5028 0.614952 11.813 0.617221C12.1232 0.619489 12.4203 0.738152 12.6417 0.948168C12.8631 1.15818 12.9914 1.44313 12.9996 1.74287C13.0078 2.04262 12.8952 2.33372 12.6856 2.55475L6.32264 10.2476C6.21323 10.3616 6.08117 10.453 5.93437 10.5165C5.78757 10.5799 5.62904 10.6141 5.46826 10.617C5.30748 10.6199 5.14775 10.5914 4.99862 10.5332C4.8495 10.475 4.71403 10.3884 4.60033 10.2785L0.380675 6.19924C0.263165 6.09339 0.168913 5.96574 0.103542 5.8239C0.0381707 5.68207 0.00301963 5.52897 0.000186137 5.37372C-0.00264735 5.21847 0.0268948 5.06425 0.0870496 4.92028C0.147204 4.77631 0.23674 4.64552 0.350315 4.53573C0.463889 4.42593 0.599176 4.33938 0.748105 4.28122C0.897034 4.22307 1.05655 4.19451 1.21715 4.19725C1.37774 4.19999 1.53612 4.23397 1.68283 4.29717C1.82955 4.36036 1.96159 4.45148 2.07109 4.56508L5.41045 7.79178L10.9489 0.969925C10.9589 0.958055 10.9696 0.946732 10.9808 0.936008H10.9792Z"
        fill="#37B482"
      />
    </svg>
  );
};

export {
  DigitalClientIcon,
  DailyHistoryIcon,
  ConsumptionAlertsIcon,
  DescriptionPlanIcon,
};
